export default __webpack_public_path__ + "static/media/ies_Signify.7c169244.png";